import React, { useEffect } from "react";
import AlertComponent from "components/Alert";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useDeleteInvitationMutation } from "redux/services/identity";

interface Props {
  isOpen: boolean;
  data?: any;
  onClose: () => void;
  onSuccess?: () => void;
}

const DeleteInvitationDialog = ({
  isOpen,
  data,
  onClose,
  onSuccess,
}: Props) => {
  const toast = useToast();
  const cancelRef = React.useRef(null);

  const [deleteInvitation, { isLoading, isSuccess, isError, error, reset }] =
    useDeleteInvitationMutation();

  const handleSubmit = () => {
    const body = {
      id: data?.id,
    };
    deleteInvitation(body);
  };

  useEffect(() => {
    if (isSuccess) {
      onSuccess?.();
      onClose?.();
      toast({
        title: `Delete invitation successfully.`,
        description: "",
        status: "success",
        duration: 9000,
        position: "top-right",
        isClosable: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  useEffect(() => {
    if (isOpen) reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={isLoading ? () => { } : onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Delete Invitation
          </AlertDialogHeader>

          <AlertDialogBody>
            {isError && error && (
              <AlertComponent
                data-testid="alert-error"
                status="error"
                mb="10px"
                title={
                  (error as any)?.data?.errors
                    ?.map((err: any) => err.message)
                    ?.join(", ") ?? "Something went wrong!"
                }
              />
            )}

            <Text fontSize="14px" lineHeight="1.5">
              Are you sure you want to delete invitation this user?
            </Text>
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} disabled={isLoading}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleSubmit}
              ml={3}
              disabled={isLoading}
            >
              Confirm
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export default DeleteInvitationDialog;
